import React from "react";
import GroupAdminSidebar from "../../Layout/GroupAdminSidebar";
import { useUser } from "../../context/AuthContext";
import MainDashboardLayout from "../../Layout/MainDashboardLayout";
import MainSidebar from "../../Layout/MainSidebar";
import Unauthorized from "../../Components/Unauthorized/Unauthorized";
import Dashboard from "./Dashboard";
import TrialUserSidebar from "../../Layout/TrailUserSidebar";

const BRSRindex = () => {
  const { user } = useUser();
  return (
    <MainDashboardLayout
      // sidebar={user?.groupManager ? <GroupAdminSidebar /> : <MainSidebar />}
      sidebar={
        user?.groupManager ? (
          <GroupAdminSidebar />
        ) : user?.isTrialUser ? (
          <TrialUserSidebar />
        ) : (
          <MainSidebar />
        )
      }
    >
      <Unauthorized requiredModule="Environment">
        <Dashboard />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default BRSRindex;
